export const customSearchStyles = (isUrdu: boolean) => {
  return {
    control: (provided: any) => ({
      ...provided,
      borderRadius: '999px',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
      textAlign: isUrdu ? 'right' : 'left',
      fontSize: '1rem',
      minHeight: '3rem',
    }),
    menu: (provided: any) => ({
      ...provided,
      overflowY: 'auto',
      zIndex: 9999,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      textAlign: isUrdu ? 'right' : 'left',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
      color: state.isDisabled ? 'red' : provided.color,
      backgroundColor: state.isDisabled ? '#f8d7da' : state.isFocused ? '#ddd' : 'white',
    }),
    input: (provided: any) => ({
      ...provided,
      textAlign: isUrdu ? 'right' : 'left',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      textAlign: isUrdu ? 'right' : 'left',
    }),
  };
};
